<ng-template #twoFactorEnabled>
  <div class="modal-lg">
    <div class="google-2fa-confirmation">
      <div class="head">
        <div style="text-align: center">
          <img
            itemprop="image"
            class="logo logo-dark mt-x1"
            alt="CoinZoom Exchange"
            src="./assets/image/icons/logo_white.svg"
            width="200"
          />
        </div>
        <span *ngIf="replace">2FA Secret Changed Successfully</span>
        <span *ngIf="!replace">2FA Enabled Successfully</span>
        <span>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">X</button>
        </span>
      </div>
      <div class="google-2fa-confirmation-body">
        <div class="row m0 py0-px15" *ngIf="replace">
          The value below is your new secret key. You can use it to set up authenticator on another device if you lose your mobile device.
          <span class="important">Back up your secret key in a secure place to safeguard your account.</span>
        </div>
        <div class="row m0 py0-px15" *ngIf="!replace">
          The value below is your secret key. You can use it to set up authenticator on another device if you lose your mobile device.
          <span class="important">Back up your secret key in a secure place to safeguard your account.</span>
        </div>
        <div class="row m0 py0-px15">
          <div class="col-md-4">
            <label class="lf1 secret-icon"> <fa-icon [icon]="faLock"></fa-icon> &nbsp;Secret Key </label>
          </div>
          <div class="col-md-7">
            <div class="key-field">
              {{ googleAuthData.key }}
            </div>
          </div>
          <div class="col-md-1">
            <fa-icon class="clipboard-icon" [icon]="faClipboard" (click)="copySecretKey()"></fa-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
